/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { frameworks, Group, standards } from '@g17eco/core';
import { RequestScope } from '../actions/api';

type ScopeOptions = Record<string, Pick<Group, 'name' | 'hidden'>>;

export interface RequestScopeExtended extends RequestScope {
  name: string;
}

const getRequestScopes = (packs: ScopeOptions, scopeType: string): RequestScopeExtended[] => {
  return Object.keys(packs).reduce((acc, key: string) => {
    if (packs[key].hidden) {
      return acc;
    }
    return [...acc, { code: key, scopeType, name: packs[key].name }];
  }, [] as RequestScopeExtended[]);
};

/** Generate request scopes with name and use as options **/
export const getRequestScopeExtended = (groupOptions: ScopeOptions | undefined): RequestScopeExtended[] => {
  return [
    ...getRequestScopes(standards, 'standards'),
    ...getRequestScopes(frameworks, 'frameworks'),
    ...(groupOptions ? getRequestScopes(groupOptions, 'custom') : []),
  ];
};
